import React from 'react';
import { Flex, Box } from '@sparrowengg/twigs-react';
import SingleApp from './single-app';
import { AllAppsProps } from '../types';
import Fallback from 'commons/components/fall-back';
import TicketIcon from 'commons/icons/ticket';

const AllApps = ({ apps, onDeleteSuccess }: AllAppsProps) => {
  return (
    <Box
      css={{
        height: 'calc(100vh - 156px - 98px )',
        overflowY: 'auto'
      }}
    >
      {apps.length ? (
        <Flex
          alignItems="flex-start"
          wrap="wrap"
          gap="$20"
          css={{ paddingBottom: '$12' }}
        >
          {apps?.map((data) => {
            const {
              appId,
              name,
              icon,
              description,
              version,
              incomingWebhookURL,
              appStatus,
              appType,
              appVersionId,
              releaseRequestId,
              releaseRequestStatus,
              status: statusFromApi
            } = data;
            const releaseStatus = releaseRequestStatus ?? statusFromApi ?? '';
            const app = {
              appId,
              name,
              versionNumber: version,
              icon,
              shortDescription: description,
              incomingWebhookURL,
              appStatus,
              appType,
              appVersionId,
              releaseRequestId,
              releaseRequestStatus,
              status: releaseStatus || undefined
            };
            return (
              <SingleApp
                key={appId}
                app={app}
                onDeleteSuccess={onDeleteSuccess}
              />
            );
          })}
        </Flex>
      ) : (
        <Flex justifyContent="center" css={{ marginTop: 160 }}>
          <Fallback
            isBlackTheme={false}
            description="Your filters worked too well! Adjust them to find the data you need."
            title="Filtered Out, but Not Lost!"
            icon={<TicketIcon />}
          />
        </Flex>
      )}
    </Box>
  );
};

export default AllApps;
